module.exports = __webpack_public_path__ + "img/Balazs.24cc6922.jpg";